var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 216,
    viewBox: "0 0 262 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_432)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.515625,
    width: 262,
    height: 215,
    rx: 7.49347,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_348_432)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.5511,
    y: 32.0166,
    width: 177.342,
    height: 138.998,
    rx: 9.58606,
    fill: "#F7FAFC",
    fillOpacity: 0.36
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 75.6632,
    cy: 56.04,
    r: 13.7039,
    fill: "#38B2AC",
    fillOpacity: 0.12,
    stroke: "#38B2AC",
    strokeWidth: 2.14969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.301,
    cy: 56.04,
    r: 13.7039,
    fill: "#38B2AC",
    fillOpacity: 0.12,
    stroke: "#38B2AC",
    strokeWidth: 2.14969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.939,
    cy: 56.04,
    r: 13.7788,
    fill: "#38B2AC",
    fillOpacity: 0.12,
    stroke: "#38B2AC",
    strokeWidth: 2,
    strokeDasharray: "4.22 4.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.689 140.236L144.631 162.652C144.939 163.185 144.555 163.85 143.94 163.85H118.056C117.441 163.85 117.057 163.185 117.364 162.652L130.306 140.236C130.614 139.704 131.382 139.704 131.689 140.236Z",
    fill: "#38B2AC",
    fillOpacity: 0.12,
    stroke: "#38B2AC",
    strokeWidth: 2.14969
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0524 140.236L88.9943 162.652C89.3017 163.185 88.9175 163.85 88.3028 163.85H62.4189C61.8042 163.85 61.42 163.185 61.7274 162.652L74.6693 140.236C74.9767 139.704 75.745 139.704 76.0524 140.236Z",
    fill: "#38B2AC",
    fillOpacity: 0.12,
    stroke: "#38B2AC",
    strokeWidth: 2.14969,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.327 140.236L200.269 162.652C200.576 163.185 200.192 163.85 199.578 163.85H173.694C173.079 163.85 172.695 163.185 173.002 162.652L185.944 140.236C186.251 139.704 187.02 139.704 187.327 140.236Z",
    fill: "#38B2AC",
    fillOpacity: 0.12,
    stroke: "#38B2AC",
    strokeWidth: 2.14969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9592,
    y: 91.0192,
    width: 27.4079,
    height: 27.4079,
    rx: 2.67189,
    fill: "#4C94FF",
    fillOpacity: 0.12,
    stroke: "#4C94FF",
    strokeWidth: 2.14969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.597,
    y: 91.0192,
    width: 27.4079,
    height: 27.4079,
    rx: 2.67189,
    fill: "#4C94FF",
    fillOpacity: 0.12,
    stroke: "#4C94FF",
    strokeWidth: 2.14969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.235,
    y: 91.0192,
    width: 27.4079,
    height: 27.4079,
    rx: 2.67189,
    fill: "#4C94FF",
    fillOpacity: 0.12,
    stroke: "#4C94FF",
    strokeWidth: 2.14969
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.07484,
    y: 1.59047,
    width: 259.85,
    height: 212.85,
    rx: 6.41862,
    stroke: "#38B2AC",
    strokeWidth: 2.14969
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_348_432",
    x: -2.1787,
    y: -3.71325,
    width: 248.802,
    height: 210.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.8649,
    result: "effect1_foregroundBlur_348_432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_432"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.515625,
    width: 262,
    height: 215,
    rx: 7.49347,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassification);
export default __webpack_public_path__ + "static/media/classification.46cc386b15c7dac9e0e847d616a8588b.svg";
export { ForwardRef as ReactComponent };